import React from "react";
import { ColorResult } from "react-color";

import { TextState, Preview } from "@creatomate/preview";
import { classnames, PlainButton } from "@culturehq/components";

import { texts } from "app/utils/creatomate-texts.json";
import { getEffectProperty, getRgbColor } from "components/stories/video-studio/utils";

interface TextEffectsOptionsProps {
  activeElement: TextState;
  color: ColorResult;
  onClose: () => void;
  onSelectedEffect: (value: string) => void;
  onSubtitleEffectChange?: (properties: { property: string; value: string }[]) => Promise<void>;
  preview: Preview;
}

interface CreatomateProperty {
  property: string;
  value: any;
}

const TextEffectsOptions: React.FC<TextEffectsOptionsProps> = ({
  activeElement, color, onClose, onSelectedEffect, onSubtitleEffectChange, preview
}) => {
  const getEffectProperties = (effects: Record<string, any>) => {
    const properties: CreatomateProperty[] = Object.entries(effects).map(([property, value]) => ({
      property,
      value
    }));
    const modifications = Object.fromEntries(
      properties.map(({ property, value }) => [`${activeElement.source.id}.${property}`, value])
    );
    return { modifications, properties };
  };

  const getEffectColorProperty = (property: string) => {
    const properties: CreatomateProperty[] = [];
    const efffectColorProperty = getEffectProperty(property);
    if (efffectColorProperty.length > 0) {
      const value = getRgbColor(color);
      properties.push({ property: efffectColorProperty, value });
      const modifications = { [`${activeElement.source.id}.${efffectColorProperty}`]: value };
      return { modifications, properties };
    }
    return { modifications: {}, properties };
  };

  const handleOnSelectTextOption = async (text: Record<string, any>) => {
    const { effects, name } = text;
    const {
      modifications: effectModifications, properties: effectProperties
    } = getEffectProperties(effects);
    const {
      modifications: effectColorModification, properties: effectColorProperty
    } = getEffectColorProperty(effects);

    const modifications = { ...effectModifications, ...effectColorModification };
    const properties = [...effectProperties, ...effectColorProperty];

    if (onSubtitleEffectChange) {
      await onSubtitleEffectChange(properties);
    } else {
      await preview.applyModifications(modifications);
    }
    onSelectedEffect(name);
    onClose();
  };

  return (
    <ul className="dropdown-menu">
      {texts.filter(text => text.designWidth !== 100 || text.name === "None").map(text => (
        <div
          className={classnames("TextOption", text.designWidth === 100 ? "col-xs-12" : "col-xs-6")}
          key={text.name}
        >
          <PlainButton onClick={() => handleOnSelectTextOption(text)}>
            <img className="TextOption-Image" src={text.image_url} alt={text.name} key={text.name} />
          </PlainButton>
        </div>
      ))}
    </ul>
  );
};

export default TextEffectsOptions;
